import _ from 'lodash';
import React from 'react';
import Card from 'react-bootstrap/Card';
import {
  FormField,
  InputText,
  Label,
  Row,
} from '../../common/form';
import Tip from '../../../../shared/tip';
import FundContext from './context';
import Header from './header';
import Pane from './pane';

export default function FeaturedWires() {
  const { state, dispatch } = React.useContext(FundContext);
  const [vals, setVals] = React.useState(state.fund.featuredWireUrls);

  const handleChange = (e, index) => {
    const newData = [...vals];
    newData[index] = e.target.value;
    setVals(newData);
    dispatch({ type: 'setFeaturedWireUrls', payload: newData });
  };

  return (
    <Card>
      <Card.Header>
        <Header eventKey="wires">Featured Wires</Header>
      </Card.Header>
      <Pane eventKey="wires">
        <Card.Body>
          {_.times(3).map(index => (
            <Row key={`featured-wire-${index}`}>
              <Label htmlFor={`featured-wire-url-${index}`}>{`Wire ${index + 1}`}</Label>
              <FormField>
                <InputText
                  id={`featured-wire-url-${index}`}
                  type="text"
                  name={`featuredWireUrl${index}`}
                  value={vals[index]}
                  placeholder="Enter a wire url"
                  onChange={e => handleChange(e, index)}
                />
              </FormField>
            </Row>
          ))}
        </Card.Body>
        <Tip text="Wires that don't have a primary image will not appear in featured wires section." />
      </Pane>
    </Card>
  );
}
